import axios from 'axios'
import { message } from 'antd';

export const PRINTERS_HAS_ERROR = 'PRINTERS_HAS_ERROR'
export const PRINTERS_IS_LOADING = 'PRINTERS_IS_LOADING'
export const PRINTERS_FETCH_DATA_SUCCESS = 'PRINTERS_FETCH_DATA_SUCCESS'
export const ADD_PRINTER_SUCCESS = 'ADD_PRINTER_SUCCESS'
export const DELETE_PRINTER_SUCCESS = 'DELETE_PRINTER_SUCCESS'
export const PRINTERS_CREATE_CACHE = 'PRINTERS_CREATE_CACHE'
export const ENABLE_PRINTER_SUCCESS = 'ENABLE_PRINTER_SUCCESS'

export function printersHasError(err) {
    return {
        type: PRINTERS_HAS_ERROR,
        error: err
    };
}

export function printersIsLoading(bool) {
    return {
        type: PRINTERS_IS_LOADING,
        isLoading: bool
    };
}

export function printersFetchDataSuccess(printers) {
    return {
        type: PRINTERS_FETCH_DATA_SUCCESS,
        printers
    };
}

export function addPrinterSuccess(printer) {
    return {
        type: ADD_PRINTER_SUCCESS,
        printer: printer
    };
}

export function enablePrinterSuccess(printer) {
    return {
        type: ENABLE_PRINTER_SUCCESS,
        printer: printer
    };
}
export function deletePrinterSuccess(items) {
    return {
        type: DELETE_PRINTER_SUCCESS,
        deleted_printers: items
    };
}

export function printersCreateCache(printers) {
    var printersCache = printers.reduce(function(hash, value) {
        var key = value['id'];
        hash[key] = value.prnName;
        return hash;
      }, {});

    return {
        type: PRINTERS_CREATE_CACHE,
        printersCache
    };
}

async function getData() {
    let maxDate = new Date();
    const res = await axios("/printer?sort=prnName&start=1&end=" + Math.round(maxDate.getTime() / 1000));
    return res.data;
  }

export function fetchPrinters() {
    return (dispatch) => {
        dispatch(printersIsLoading(true));

        getData()
        .then(response => {
            dispatch(printersIsLoading(false));
            dispatch(printersFetchDataSuccess(response));
            dispatch(printersCreateCache(response));
        })
        .catch(err => 
        {
            dispatch(printersHasError(err));
        })
        }
    }

    export function addNetworkPrinter(device)
    {
        const deviceData = {
            'ipAddress': device,
            'enabled': 1,
            'network': 1};

        return (dispatch) => {
            axios.post('/printer', deviceData)
            .then(response => {
                dispatch(addPrinterSuccess(response.data));
            })
            .catch(err => {
                message.error(err.message);
            })
        }
    }    
    
    export function deletePrinters(items_to_delete)
    {
        return (dispatch) => {
        let promises = [];
    
        items_to_delete.forEach(item => {
        promises.push(axios.delete('/printer/' + item))
        });
    
        axios.all(promises)
        .then(results => {
            dispatch(deletePrinterSuccess(items_to_delete));
        })
        .catch(err => {
            message.error(err.message);
        })
        }
    }

export function enablePrinter(deviceData) {
    return (dispatch) => {
        return axios.post('/enable_printer', deviceData)
            .then(response => {
                dispatch(enablePrinterSuccess(deviceData));
                return response.data;
            })
            .catch(err => {
                throw err;
            });
    };
}       
    